import InputTextCP from './InputTextCP'

export default class InputNumberCP extends InputTextCP {
  inputType = 'number'
  
  constructor(props) {
    super(props)
  }

  _onChange(event) {
    this.props.onChange(event, Number(event.target.value), this.props.objPath)
  } 
}
